import { useEffect, useState } from 'react';
import { isIOS } from 'react-device-detect';
import { Grid, Image, Typography } from 'antd';

import classes from './index.module.less';

const JourneyContainerNew = () => {
	const { xs } = Grid.useBreakpoint();
	const [checkDevice, setCheckDevice] = useState(String);
	useEffect(() => {
		const handleDeviceDetection = () => {
			if (isIOS) {
				setCheckDevice('ios');
			} else {
				setCheckDevice('no-ios');
			}
		};

		handleDeviceDetection();
	}, []);

	return (
		<div className={classes.headjourney}>
			<div className={classes.headContact}>
				<h2 className={classes.title} style={{ marginBottom: '-5px' }}>
					Bantu Mama rencanain kehamilan sampai si Kecil
					<br />
					<span> lahir dan tumbuh dengan fitur - fitur seru!</span>
				</h2>
				<Typography className={classes.paragraph}>
					Kami siap bantu Mama pahami setiap fase, biar Mama bisa dukung tumbuh kembang si Kecil
					dengan cara terbaik!
				</Typography>
				<div className={classes.contentjourney}>
					<div className={classes.container1}>
						<div className={classes.box1}>
							<div className={classes.imgJourney1}>
								<h3 className={classes.titleJourney}>
									Fase <span className={classes.netralcolor}>Pra Kehamilan</span>
								</h3>
								<Typography className={classes.paragraphJourney}>
									Mama Papa akan ditemenin langkah demi langkah buat persiapin kehamilan yang sehat
									dan bahagia. Ini lho yang Mama akan dapetin
								</Typography>
								<div className={classes.pointJourney}>
									<Typography className={classes.pointParagraphJourney}>
										<Image
											src="/images/default/check-circle-fill.svg"
											className={classes.circleImage}
											alt="circlefill"
											width={16}
											height={16}
										/>
										<span>Notifikasi waktu subur Mama</span>
									</Typography>
									<Typography className={classes.pointParagraphJourney}>
										<Image
											src="/images/default/check-circle-fill.svg"
											className={classes.circleImage}
											alt="circlefill"
											width={16}
											height={16}
										/>
										<span>Kalender kesuburan Mama</span>
									</Typography>
									<Typography className={classes.pointParagraphJourney}>
										<Image
											src="/images/default/check-circle-fill.svg"
											className={classes.circleImage}
											alt="circlefill"
											width={16}
											height={16}
										/>
										<span>Rekomendasi artikel buat Mama</span>
									</Typography>
								</div>
							</div>
						</div>
						<div className={classes.box2}>
							<div className={classes.borderRight}>
								<Image src="/images/branda/journey/atr-journey1.webp" width={77} height={77} alt="image-atribut-journey1" preview={false} />
								{/* <Image src="/images/test/heart.svg" alt="image" preview={false} /> */}
							</div>
							<div className={classes.imgJourney1}>
								{xs && checkDevice === 'ios' ? (
									<Image src="/images/branda/journey/journey-1.webp" alt="image-journey1" preview={false} />
								) : xs ? (
									<Image src="/images/branda/journey/journey-1.webp" alt="image-journey1" preview={false} />
								) : (
									<Image src="/images/branda/journey/journey-1.webp" alt="image-journey1" preview={false} />
								)}
							</div>
						</div>
					</div>
					<div className={classes.container2}>
						<div className={classes.box1}>
							<div className={classes.borderLeft}>
								<Image src="/images/branda/journey/atr-journey2.webp" width={77} height={77} alt="image-atribut-journey2" preview={false} />
							</div>
							<div className={classes.imgJourney2}>
								{xs && checkDevice === 'ios' ? (
									<Image src="/images/branda/journey/journey-2.webp" width={300} height={303} alt="image-journey2" preview={false} />
								) : xs ? (
									<Image src="/images/branda/journey/journey-2.webp" width={300} height={303} alt="image-journey2" preview={false} />
								) : (
									<Image src="/images/branda/journey/journey-2.webp" width={358} height={344} alt="image-journey-2" preview={false} />
								)}
							</div>
						</div>
						<div className={classes.box2}>
							<h3 className={classes.titleJourney2}>
								Fase <span className={classes.netralcolor}> Kehamilan</span>
							</h3>
							<Typography className={classes.paragraphJourney}>
								Mulailah percakapan denganku 👶🏻 sejak masih di dalam kandungan. Kami hadir untuk
								memastikan Mama nggak akan lewatin satu momen pun dalam setiap perjalanan
							</Typography>
						</div>
					</div>
					<div className={classes.container3}>
						<div className={classes.box1}></div>
						<div className={classes.box2}></div>
					</div>
					<div className={classes.container4}>
						<div style={{ float: 'left', zIndex: 2 }}>
							<h3 className={classes.titleJourney3}>
								Fase <span className={classes.netralcolor}> Tumbuh Kembang </span> Anak
							</h3>
							<Typography className={classes.paragraphJourney3}>
								Catat momen tumbuh kembangku yuk Ma!
							</Typography>
							<Typography className={classes.paragraphJourney3}>
								dengan memperhatikan informasi dan tips yang bagus buat Mama.
							</Typography>
						</div>
						<div style={{ float: 'right', zIndex: 0 }}>
							<Image
								src="/images/branda/journey/journey-3.webp"
								alt="image-journey3"
								preview={false}
								className={classes.imageJourney3}
							/>
						</div>
						<div className={classes.borderRightBottom}>
							<Image src="/images/test/Segitiga.svg" alt="image" preview={false} />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default JourneyContainerNew;
